import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class SentienceDeviceManager {
    constructor(private http: AdalHttp) {
    }

    getAvailableIotHubs(tenant: string): Observable<any> {
        let productUrl: string = `api/tenants/${tenant}/settings/iothubs/`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getSystemStatus(iotHub: string, systemGuid: string): Observable<any> {
        let productUrl: string = `api/systemdetail/iothub/${iotHub}/systems/${systemGuid}/status/`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    changeSystemStatus(iotHub: string, systemGuid: string, systemStatus: string): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var requestBody = {
            'SystemStatus': systemStatus
        };
        let productUrl: string = `api/systemdetail/iothub/${iotHub}/systems/${systemGuid}/status/`;
        return this.http.post(productUrl, JSON.stringify(requestBody), {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}

export enum SystemStatus {
    Disabled = 0,
    Enabled = 1
}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/sentienceDeviceManager/sentience-device-manager.service.ts
 **/